<template>
  <div>
    <div>
      <div class="index">
        <div class="name">
          <div style="display: flex">
            <img src="../../../assets/touxiang.png" />
            <span style="letter-spacing: 2px; color: rgb(0, 0, 0)">{{ name }}</span>
          </div>
        </div>
        <!-- 列表 -->
        <div class="list">
          <van-cell-group>
            <van-cell title="成为会员" is-link icon="star" @click="memberList" />
            <van-cell title="收货地址" is-link icon="location" @click="receiptAddress" />
            <!-- <van-cell title="申报记录" is-link icon="todo-list"  @click="shenbaoList"/> -->
          </van-cell-group>
        </div>
      </div>
    </div>
    <!-- 底部菜单 -->
    <div>
      <van-tabbar
        v-model="activeTab"
        v-if="fwStyle == '2'"
        @change="onChangeTab"
        active-color="#ffc002"
        inactive-color="#000"
      >
        <van-tabbar-item icon="home-o">首页</van-tabbar-item>
        <van-tabbar-item icon="chat-o">订单</van-tabbar-item>
        <van-tabbar-item icon="manager-o">我的</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>
<script>
import {} from '@/api/ylOrder.js'
import { setOpenId, getOpenId, getfwStyle } from '@/utils/auth'
import { WeGetMemberByOpenID } from '@/api/yeguang'
export default {
  data() {
    return {
      activeTab: 2,
      fwStyle: '',
      name: '微信用户',
    }
  },
  created() {
    this.MemberInfo()
    this.fwStyle = getfwStyle()
  },
  methods: {
    MemberInfo() {
      WeGetMemberByOpenID({ openID: getOpenId() }).then((res) => {
        if (res.data.code == '0') {
          this.name = res.data.data.Name
        }
      })
    },
    // 底部导航栏切换
    onChangeTab: function(row) {
      console.log(row)
      if (row == '0') {
        if (window.__wxjs_environment === 'miniprogram') {
          window.wx.miniProgram.redirectTo({
            url: '../meiTuan/meiTuanShouYe?path=/ylOrder',
          })
        } else {
          this.$router.push({
            path: '/ylOrder',
          })
        }
      }
      if (row == '1') {
        if (window.__wxjs_environment === 'miniprogram') {
          window.wx.miniProgram.redirectTo({
            url: '../public/goto?path=/ylOrder/orderList',
          })
        } else {
          this.$router.push({
            path: '/ylOrder/orderList',
          })
        }
        // this.$router.push({
        //   path: "/ylOrder/orderList",
        // });
      }
    },
    // 跳转会员
    memberList() {
      if (window.__wxjs_environment === 'miniprogram') {
        window.wx.miniProgram.navigateTo({
          url: '../public/goto?path=/ylOrder/memberList',
        })
      } else {
        this.$router.push({
          path: '/ylOrder/memberList',
        })
      }
    },
    // 收货地址
    receiptAddress() {
      if (window.__wxjs_environment === 'miniprogram') {
        window.wx.miniProgram.navigateTo({
          url: '/pages/meiTuan/receiptAddress/index',
        })
      } else {
        alert('请在小程序中打开')
      }
    },
    // 申报记录
    shenbaoList() {
      this.$router.push({
        path: '/ylOrder/declare/declareList?openid=' + getOpenId(),
      })
    },
  },
}
</script>
<style scoped>
.index {
  position: relative;
  height: 100vh;
  /* background: #f7faff; */
  background: url(https://xajmylapi.anluoyun.cn//upload/images/2022/11/efea763d-7c5.png) no-repeat center center;
  background-size: 100% 100%;
}

/* 信息 */
.name {
  width: 100%;
  height: 130px;
  /* background: #02c08f; */
}

.name div {
  width: 80%;
  /* text-align: center; */
  margin: auto;
  padding: 25px 0;
}

.name img {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background: #fff;
  overflow: hidden;
}

.name span {
  display: block;
  /* width: 80%; */
  padding: 4px 0%;
  margin: 0 10%;
  text-align: center;
  font-size: 18px;
  line-height: 85px;
}

/* 列表 */
.list {
  width: 90%;
  margin: 10px 4%;
  padding: 5px;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 0 5px #e4e3e3;
}
</style>
